import React from 'react';

const Field = (props) => (
    <div className="form-group">
        {props.label && <label>{props.label}</label> }
        <input
            type={props.type}
            name={props.name}
            className={props._className}
            placeholder={props.placeholder}
            value={props.value}
            onChange={props.onChange}
            readOnly = {props.readOnly}

        />
        {props.error &&
            <div className="invalid-feedback">
              { props.errorMessage ?  props.errorMessage : `Le champ ${props.label.replace('*','')} est obligatoire` }
            </div>
        }
    </div>
)

export default Field;


// WEBPACK FOOTER //
// ./src/components/Common/Field.js